/**
 * Ask the public site to drop cached compare default pages after admin saves.
 */
export async function revalidateCompareDefaultsOnFrontend() {
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "");
  const secret = process.env.REACT_APP_SANITY_REVALIDATE_SECRET;

  if (!frontendUrl || !secret) {
    return { skipped: true };
  }

  const url = `${frontendUrl}/api/revalidate?secret=${encodeURIComponent(secret)}&scope=compare-defaults`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scope: "compare-defaults" }),
  });

  if (!response.ok) {
    throw new Error(`Revalidate failed (${response.status})`);
  }

  return response.json();
}
